import { initData } from './telegram'

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code = 'error',
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

async function request<TResult>(path: string, options: RequestInit = {}): Promise<TResult> {
  const response = await fetch(path, {
    ...options,
    headers: {
      'content-type': 'application/json',
      'x-telegram-init-data': initData(),
      ...(options.headers ?? {}),
    },
  })
  const text = await response.text()
  const payload = text ? (JSON.parse(text) as Record<string, unknown>) : {}
  if (!response.ok) {
    throw new ApiError(
      typeof payload.error === 'string' ? payload.error : 'Что-то сломалось. Попробуй ещё раз',
      response.status,
      typeof payload.code === 'string' ? payload.code : 'error',
    )
  }
  return payload as TResult
}

export const api = {
  get: <TResult>(path: string) => request<TResult>(path),
  post: <TResult>(path: string, body?: unknown) =>
    request<TResult>(path, { method: 'POST', body: JSON.stringify(body ?? {}) }),
}
